// Version manager to handle localStorage cleanup on version changes
const APP_VERSION = '1.0.0'
const VERSION_KEY = 'insightflow_app_version'

export const checkAndClearOldData = async () => {
  try {
    const storedVersion = localStorage.getItem(VERSION_KEY)
    
    if (!storedVersion || storedVersion !== APP_VERSION) {
      console.log('App version changed or first load, clearing old data...')
      
      // Clear service workers
      if ('serviceWorker' in navigator) {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations()
          for (const registration of registrations) {
            await registration.unregister()
            console.log('Service worker unregistered')
          }
        } catch (error) {
          console.warn('Could not unregister service workers:', error)
        }
      }
      
      // Clear specific localStorage items but preserve authentication and critical data
      const keysToPreserve = [
        'sb-', // Supabase auth keys
        'supabase.auth.token', // Supabase auth token
        'i18nextLng', // Language preference
        VERSION_KEY // Version key itself
      ]
      
      const allKeys = Object.keys(localStorage)
      let clearedCount = 0
      
      allKeys.forEach(key => {
        const shouldPreserve = keysToPreserve.some(preserveKey => 
          key.startsWith(preserveKey) || key === preserveKey
        )
        if (!shouldPreserve) {
          localStorage.removeItem(key)
          clearedCount++
        }
      })
      
      console.log(`Cleared ${clearedCount} localStorage items`)
      
      // Clear sessionStorage as well (but be more careful)
      try {
        // Only clear sessionStorage if it's not critical for the current session
        const sessionKeys = Object.keys(sessionStorage)
        sessionKeys.forEach(key => {
          // Preserve any authentication-related session data
          if (!key.startsWith('sb-') && !key.includes('auth')) {
            sessionStorage.removeItem(key)
          }
        })
      } catch (error) {
        console.warn('Could not clear sessionStorage:', error)
      }
      
      // Set the new version
      localStorage.setItem(VERSION_KEY, APP_VERSION)
      console.log(`App version updated to ${APP_VERSION}`)
    } else {
      console.log(`App version ${APP_VERSION} is current`)
    }
  } catch (error) {
    console.warn('Could not access localStorage for version check:', error)
  }
}

export const getAppVersion = () => APP_VERSION 